<template>
  <b-modal
    v-model="isOpen"
    scrollable
    centered
    :title="title"
    size="md"
    no-close-on-backdrop
    @hidden="onClose"
    @ok="onClose"
  >
    <div style="min-height: 350px">
      <div class="mb-3">
        <div class="mb-2">
          Инициатор
        </div>
        <v-select
          v-model="$v.selectedInitiators.$model"
          :options="initiators"
          :error="$v.selectedInitiators.$error"
          :errors="errorsValidation.selectedInitiators"
          placeholder="Выберите инициатора"
          fluid
          label="name"
        />
        <div
          v-if="$v.selectedInitiators.$error"
          class="text-danger mb-2 small"
        >
          {{ errorsValidation.selectedInitiators[0] }}
        </div>
      </div>

      <div>
        <div class="mb-2">
          Причина отмены консультации
        </div>
        <base-async-select
          :key="selectedInitiators ? selectedInitiators.id : null"
          v-model="$v.selectedTransferReason.$model"
          :error="$v.selectedTransferReason.$error"
          :fetch-function="fetchTransferReasons"
          placeholder="Выберите причину"
          loading-title="Загрузка"
          no-options-title="Причины не найдены"
          server-paginated
          fluid
        />
        <div
          v-if="$v.selectedTransferReason.$error"
          class="text-danger mb-2 small"
        >
          {{ errorsValidation.selectedTransferReason[0] }}
        </div>
      </div>
    </div>
    <template #modal-footer>
      <b-button
        variant="primary"
        :disabled="isCanceling"
        class="float-right"
        @click="cancelConsultation"
      >
        Отмена консультации
        <b-spinner
          v-if="isCanceling"
          variant="light"
          small
        />
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Bus from '@/eventBus';
import { BaseAsyncSelect } from '@/components/base';
import { showMessage } from '@/helpers/utils';

export default {
  name: 'ConsultationCancelModal',
  components: {
    BaseAsyncSelect,
  },
  mixins: [validationMixin],
  props: {
    consultation: {
      type: Object,
      default: () => ({}),
    },
    modalName: {
      type: [String, Number],
      default: null,
    },
    title: {
      type: String,
      default: 'Отмена консультации',
    },
    cb: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isOpen: true,
      isCanceling: false,
      selectedTransferReason: null,
      selectedInitiators: null,
      initiators: [
        {
          id: 0,
          name: 'Врач',
        },
        {
          id: 1,
          name: 'Пациент',
        },
        {
          id: 2,
          name: 'Техническая ошибка',
        },
        {
          id: 3,
          name: 'Администратор',
        }],
    };
  },
  validations() {
    return {
      selectedInitiators: {
        required,
      },
      selectedTransferReason: {
        required,
      },
    };
  },
  computed: {
    errorsValidation() {
      const errors = {};

      errors.selectedTransferReason = [];
      if (!this.$v.selectedTransferReason.required) {
        errors.selectedTransferReason.push('Поле не может быть пустым');
      }

      errors.selectedInitiators = [];
      if (!this.$v.selectedInitiators.required) {
        errors.selectedInitiators.push('Поле не может быть пустым');
      }
      return errors;
    },
  },
  methods: {
    onClose() {
      this.$store.commit(this.$types.CLOSE_MODAL, { modalName: this.modalName });
    },
    async fetchTransferReasons() {
      const type = this.selectedInitiators.id;
      const reasons = await this.$store.dispatch(this.$types.TRANSFER_REASONS_FETCH, type);

      return reasons.map((reason) => ({ ...reason, value: reason.id, name: reason.reason }));
    },
    async cancelConsultation() {
      this.$v.$touch();

      if (this.$v.$error) {
        showMessage({
          type: 'warning',
          title: 'Ошибка валидации',
          message: 'Проверьте правильность заполнения полей',
        });

        return;
      }

      try {
        this.isCanceling = true;
        await this.$store.dispatch(this.$types.CONSULTATIONS_CANCEL, {
          consultationId: this.consultation.id,
          cancelReason: this.selectedTransferReason.id,
        });

        Bus.$emit('consultations:update', this.consultation.id);
        this.$store.commit(this.$types.PATIENT_DETAIL_CONSULATIONS_RESET);
        this.$store.commit(this.$types.TOGGLE_SCHEDULE_TRIGGER); // сделает тогл триггера и обновит расписание
        this.onClose();
      } finally {
        this.isCanceling = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
